export const habilitarCampoNome = ({
  ehAcessoAdministrativo,
  formularioPermiteEdicao,
  ehFormularioDeConjuge,
  ehCriacao,
  consultarNome,
  ambienteDeProducao,
}: {
  ehAcessoAdministrativo: boolean;
  formularioPermiteEdicao: boolean;
  ehFormularioDeConjuge: boolean;
  ehCriacao: boolean;
  consultarNome: boolean;
  ambienteDeProducao: boolean;
}) => {
  const trava = ehFormularioDeConjuge && ehCriacao ? consultarNome : ambienteDeProducao;
  return (ehAcessoAdministrativo || !trava) && formularioPermiteEdicao;
};
